import {Injectable} from '@angular/core';
import {State} from '../state';
import {CommandHandlerRegistryService} from './command-registry.service';
import {Command} from './command';
import {CommandHandlerConfiguratorService} from '../command-handler-configurator.service';

@Injectable()
export class CommandBusService {
  private configured = false;

  constructor(private registry: CommandHandlerRegistryService,
              private configurator: CommandHandlerConfiguratorService) {
  }

  dispatch(state: State, command: Command): State {
    if (!this.configured) {
      this.configurator.configure(this.registry);
      this.configured = true;
    }
    const handler = this.registry.fetch(command.name);
    if (!handler) {
      throw new Error(`No registered handler for command "${command.name}".`);
    }

    return handler.handle(state, command);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/command/command-bus.service.ts